const REDUX_WORKFLOW_FILTERS = 'REDUX_WORKFLOW_FILTERS';
const REDUX_WORKFLOW_SEARCH = 'REDUX_WORKFLOW_SEARCH';

export {
    REDUX_WORKFLOW_FILTERS,
    REDUX_WORKFLOW_SEARCH,
};
